import { omniAtom, omniAtomWithStorage } from "src/utils/atoms";
import { TourSeenStatus, TourState } from "./types";

const prefix = "tour";

/** Not persisted: a reload mid-exercise ends it, and the sidebar starts it again. */
export const tourStateAtom = omniAtom<TourState | null>({
  prefix,
  key: "state",
  value: null,
});

/** The start in flight, if any: dismissing the offer clears it so its late answer is dropped. */
export const tourStartingAtom = omniAtom<symbol | null>({
  prefix,
  key: "starting",
  value: null,
});

/**
 * Who has been offered the exercise, by user id. Kept in this browser only, so
 * the offer comes back on another machine: a missed offer costs more than a
 * repeated one.
 */
export const tourSeenAtom = omniAtomWithStorage<Record<string, TourSeenStatus>>({
  prefix,
  key: "planogramExercise/seen",
  value: {},
});
